import Permission from './Permission';
export default Permission;
